import { render } from "./fhqk.vue?vue&type=template&id=33586faa&scoped=true&ts=true"
import script from "./fhqk.vue?vue&type=script&lang=ts"
export * from "./fhqk.vue?vue&type=script&lang=ts"

import "./fhqk.vue?vue&type=style&index=0&id=33586faa&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33586faa"]])

export default __exports__